module.exports = __webpack_public_path__ + "img/card2.6da9cfc0.svg";